import { LoginMethodIcon } from '@rhg/components/login-method-icon';
import useAccount from '@rhg/hooks/use-account';
import { useLoginMethod } from '@rhg/hooks/use-login-method';
import landingMessages from '@rhg/lang/messages/landing';
import { Box, SxProps, Theme, Typography } from '@rhg/libs/material';
import { useIntl } from 'react-intl';

export default function LoginMethod({
    sx,
    showCaption,
}: {
    sx?: SxProps<Theme>;
    showCaption?: boolean;
}) {
    const { formatMessage } = useIntl();
    const { account } = useAccount();
    const loginMethod = useLoginMethod();

    if (!loginMethod) return null;

    const text =
        loginMethod === 'Apple'
            ? formatMessage(landingMessages['landing.apple_id'])
            : account?.email;

    if (!text) return null;

    const methodRow = (
        <Box display="flex" gap={2} alignItems="center" sx={sx}>
            <LoginMethodIcon loginMethod={loginMethod} />
            <Typography variant="body2" component="p" color="text.body">
                {text}
            </Typography>
        </Box>
    );

    if (!showCaption) return methodRow;

    return (
        <>
            <Typography component="p" variant="caption" color="text.sub">
                {formatMessage(landingMessages['landing.account_sign_in'])}
            </Typography>
            {methodRow}
        </>
    );
}
